webpackJsonp([0],{

/***/ 2:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, Modernizr) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return queries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return toggleVideoPlayBack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateHash; });
/* unused harmony export resetParentWidth */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setParentWidth; });
/* unused harmony export setHeight */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return objectFitter; });
var queries = {
  desktop: '(min-width:1024px)',
  // desktop: '(min-width:1024px) and (min-height:768px)',
  mobile: '(max-width:1023px)'
};

var toggleVideoPlayBack = function toggleVideoPlayBack(type, $video) {
  if ($video.length > 0) {
    if (type === 'enter') {
      $($video).get(0).play();
    }

    if (type === 'leave') {
      $($video).get(0).pause();
    }
  }
};

var updateHash = function updateHash(id) {
  var target = '#' + id;

  if (id === 'landing-default') {
    target = ' ';
  }

  history.replaceState(null, document.title, target);
};

var resetParentWidth = function resetParentWidth($container) {
  $container.css({ width: '' });
};

var setParentWidth = function setParentWidth($container, node) {
  var $section = $container.children(node);
  var totalWidth = 0;

  $section.each(function (i, el) {
    var $this = $(el);
    totalWidth += $this.outerWidth(true);
  });

  $container.width(Math.ceil(totalWidth));
};

var setHeight = function setHeight($container) {
  var windowHeight = $(window).innerHeight();
  $container.height(windowHeight);
};

var objectFitter = function objectFitter(parent, children) {

  if (!Modernizr.objectfit || /Edge/.test(navigator.userAgent) && children === 'video') {

    $(parent).each(function () {
      //set size
      var th = $(this).height(),
          //box height
      tw = $(this).width(),
          //box width
      im = $(this).children(children),
          //image
      ih = im.height(),
          //inital image height
      iw = im.width(); //initial image width
      if (ih > iw) {
        //if portrait
        im.css({ width: '100%', height: 'auto' }); //set width 100%
      } else {
        //if landscape
        im.css({ width: 'auto', height: '100%' }); //set height 100%
      }
      //set offset
      var nh = im.height(),
          //new image height
      nw = im.width(),
          //new image width
      hd = (nh - th) / 2,
          //half dif img/box height
      wd = (nw - tw) / 2; //half dif img/box width
      if (nh < nw) {
        //if portrait
        im.css({ marginLeft: '-' + wd + 'px', marginTop: 0 }); //offset left
      } else {
        //if landscape
        im.css({ marginTop: '-' + hd + 'px', marginLeft: 0 }); //offset top
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(5)))

/***/ }),

/***/ 29:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CircleButtonAnimation; });
var CircleButtonAnimation = function CircleButtonAnimation($button) {
  var circle = $button.find('circle.circle');

  if (circle.length > 0) {

    var animation = new TimelineMax({ paused: true });

    animation.to(circle, 1, {
      ease: Power0.easeNone,
      strokeDashoffset: 0,
      onComplete: function onComplete() {
        completedCircle($button, animation);
      }
    });

    $button.on({
      mouseenter: function mouseenter(e) {
        enterState(e, animation);
      },

      mouseleave: function mouseleave(e) {
        leaveState(e, animation);
      },

      click: function click(e) {
        clickState(e, animation);
      }
    });
  }
};

var clickState = function clickState(e, animation) {
  animation.timeScale(3);

  if ($(e.currentTarget).hasClass('active')) {
    $(e.currentTarget).removeClass('active');
    animation.reverse();
  } else {
    $(e.currentTarget).addClass('active');
    animation.play();
  }
};

var enterState = function enterState(e, animation) {
  window.circleAnimComplete = false;
  animation.play();
  animation.timeScale(.5);
};

var leaveState = function leaveState(e, animation) {
  window.circleAnimComplete = false;
  animation.timeScale(3);

  if ($(e.currentTarget).hasClass('active')) {
    animation.timeScale(3);
  } else {
    animation.reverse();
  }
};

var completedCircle = function completedCircle($button, animation) {
  window.circleAnimComplete = true;

  if ($button.hasClass('tooltip-btn')) {
    $button.closest('.tooltip').addClass('show');
    $button.addClass('active');
    return;
  }

  $button.trigger('click');

  if ($button.hasClass('play-video') || $button.hasClass('video-close') || $button.hasClass('circle-btn') || $button.hasClass('close-slider')) {
    $button.removeClass('active');

    animation.pause();

    setTimeout(function () {
      animation.progress(0);
    }, 1000);
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_LazyLoadController__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__controllers_ScrollController__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__controllers_MenuController__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__controllers_TooltipController__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__controllers_ProductSliderController__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__controllers_VideoController__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__controllers_FormController__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__controllers_MenuFontController__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__controllers_MailController__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__controllers_AgecheckController__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__controllers_CircleButtonController__ = __webpack_require__(97);












window.isHorizontal = false;
window.allowScroll = true;
window.scrollPos = $(window).scrollLeft();
window.circleAnimComplete = true;

window.addEventListener('load', function () {
  $(window).resize(function (e) {
    $(window).trigger("window:resize");
  });

  Object(__WEBPACK_IMPORTED_MODULE_1__controllers_ScrollController__["a" /* ScrollController */])();
  Object(__WEBPACK_IMPORTED_MODULE_2__controllers_MenuController__["a" /* MenuController */])();
  Object(__WEBPACK_IMPORTED_MODULE_0__controllers_LazyLoadController__["a" /* LazyLoadController */])();
  Object(__WEBPACK_IMPORTED_MODULE_3__controllers_TooltipController__["a" /* TooltipController */])();
  Object(__WEBPACK_IMPORTED_MODULE_4__controllers_ProductSliderController__["a" /* ProductSliderController */])();
  Object(__WEBPACK_IMPORTED_MODULE_5__controllers_VideoController__["a" /* VideoController */])();
  Object(__WEBPACK_IMPORTED_MODULE_6__controllers_FormController__["a" /* FormController */])();
  Object(__WEBPACK_IMPORTED_MODULE_7__controllers_MenuFontController__["a" /* MenuFontController */])();
  Object(__WEBPACK_IMPORTED_MODULE_8__controllers_MailController__["a" /* MailController */])();
  Object(__WEBPACK_IMPORTED_MODULE_9__controllers_AgecheckController__["a" /* AgecheckController */])();
  Object(__WEBPACK_IMPORTED_MODULE_10__controllers_CircleButtonController__["a" /* CircleButtonController */])();

  setTimeout(function () {
    $('.loader__container').addClass('hide');

    setTimeout(function () {
      $('.loader__container').addClass('hidden');
    }, 500);
  }, 500);
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LazyLoadController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vanilla_lazyload_dist_lazyload__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vanilla_lazyload_dist_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vanilla_lazyload_dist_lazyload__);


var LazyLoadController = function LazyLoadController() {
	var myLazyLoad = new __WEBPACK_IMPORTED_MODULE_0_vanilla_lazyload_dist_lazyload___default.a({
		elements_selector: ".lazy"
	});
};

/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, enquire) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery_mousewheel__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery_mousewheel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery_mousewheel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Utils__ = __webpack_require__(2);



var is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
var hash = location.hash.substr(1);
var $scrollContainer = $('#sidescroll');

var ScrollController = function ScrollController() {

  enquire.register(__WEBPACK_IMPORTED_MODULE_1__utils_Utils__["b" /* queries */].desktop, {
    match: function match() {
      window.isHorizontal = true;

      if ($('.scroll-indicator').length < 1) {
        $('body').append('<div class="scroll-indicator"><div class="scroll-indicator__progress"></div></div>');
      }

      controlParentSize($scrollContainer, '.section');
      sideScroll($scrollContainer);
    },

    unmatch: function unmatch() {
      window.isHorizontal = false;
      unsetParentSize($scrollContainer);
      unsetHeaderItemClass();

      $('html, body').off("DOMMouseScroll mousewheel");

      if ($('.scroll-indicator').length > 0) {
        $('.scroll-indicator').remove();
      }
    }
  });

  menuItems();
  logoClick();

  if (hash) {
    scrollToSection(hash, window.isHorizontal);
  }
};

var sideScroll = function sideScroll($parent) {
  //$.event.props.push("wheelDelta");
  $.easing.easeOutQuint = function (x, t, b, c, d) {
    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
  };

  var docH = $(document).width() - $(window).width();
  // let scrollLeft = $(window).scrollLeft();
  var scrollTween = void 0;

  $('html, body').on('DOMMouseScroll mousewheel', function (e, delta) {
    if (window.allowScroll) {
      if (is_safari) {
        noScrollEasing(e, delta);
      } else {
        scrollEasing(e, delta, docH, scrollTween);
      }
    }
  });
};

var scrollEasing = function scrollEasing(e, delta, docH, scrollTween) {
  // clamp the scroll offset
  delta *= 2;
  window.scrollPos = Math.min(docH, Math.max(0, window.scrollPos - (delta || e.wheelDelta)));

  //TweenMax.to('body, html')
  if (scrollTween !== undefined) {
    scrollTween.kill();
  }
  scrollTween = TweenMax.to(window, 1.5, {
    scrollTo: {
      y: 0,
      x: window.scrollPos
    },
    onUpdate: function onUpdate() {
      scrollIndicator();
      setHeaderItemClass();
    }
  });
};

var noScrollEasing = function noScrollEasing(e, delta) {
  var $this = e.currentTarget;

  if (window.allowScroll) {
    if (Math.abs(e.originalEvent.deltaX)) {
      $this.scrollLeft -= e.originalEvent.deltaX * 3 * -1;
    } else {
      $this.scrollLeft -= delta * 3 * -1 * -1;
    }

    window.scrollPos = $(window).scrollLeft();

    scrollIndicator();
    setHeaderItemClass();
  }
  e.preventDefault();
};

var logoClick = function logoClick() {
  $('.logo a, .logo-lrg a').click(function (e) {
    var $this = $(e.currentTarget);
    var target = $this.attr('data-target');

    $('body').removeClass('show-menu');
    window.allowScroll = true;

    scrollToSection(target);

    e.preventDefault();
    e.stopPropagation();
  });
};

var menuItems = function menuItems() {
  $('.main-nav__item').click(function (e) {
    var $this = $(e.currentTarget);
    var target = $this.attr('data-target');

    $('body').removeClass('show-menu');
    window.allowScroll = true;

    scrollToSection(target);

    e.preventDefault();
    e.stopPropagation();
  });
};

var scrollToSection = function scrollToSection(target) {
  var $el = $('#' + target);
  var pos = 0;

  if (window.isHorizontal) {

    if ($el.length > 0) {
      pos = $el.offset().left;
    }

    $('html, body').animate({
      scrollLeft: pos
    }, 500);

    window.scrollPos = pos;

    scrollIndicator();
    setHeaderItemClass();
  } else {

    if ($el.length > 0) {
      pos = $el.offset().top;
    }

    $('html, body').animate({
      scrollTop: pos
    }, 500);

    window.scrollPos = pos;
  }
};

var controlParentSize = function controlParentSize($parent, children) {
  if ($parent.length > 0) {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_Utils__["c" /* setParentWidth */])($parent, children);

    $(window).on("window:resize", function (e) {
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_Utils__["c" /* setParentWidth */])($parent, children);
    });
  }
};

var unsetParentSize = function unsetParentSize($parent) {
  if ($parent.length > 0) {
    $parent.css({ width: '' });

    $(window).on("window:resize", function (e) {
      $parent.css({ width: '' });
    });
  }
};

var setHeaderItemClass = function setHeaderItemClass() {
  var $headerItems = $('.social-nav li, .logo, #pagetitle, .toggle-menu');
  var sectionPos = document.querySelector('.section.brewery').getBoundingClientRect().x;

  $headerItems.each(function (i, el) {
    var elBounding = el.getBoundingClientRect();
    var elCenter = elBounding.x + elBounding.width / 2;

    if (sectionPos < elCenter) {
      $(el).addClass('dark');
    } else {
      $(el).removeClass('dark');
    }
  });
};

var unsetHeaderItemClass = function unsetHeaderItemClass() {
  var $headerItems = $('.social-nav li, .logo, #pagetitle, .toggle-menu');
  $headerItems.each(function (i, el) {
    $(el).removeClass('dark');
  });
};

var scrollIndicator = function scrollIndicator() {
  var documentWidth = $(document).width();
  var windowWidth = $(window).width();
  var scrollPosition = window.scrollPos;
  var positionPercentage = scrollPosition / documentWidth * 100;
  var offset = windowWidth / documentWidth * positionPercentage;
  var percentage = positionPercentage + offset;
  // console.log(percentage);
  $('.scroll-indicator__progress').css({ 'width': percentage > 95 ? Math.ceil(percentage) + 1 + '%' : percentage + '%' });
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(1)))

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, enquire) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_Utils__ = __webpack_require__(2);


var MenuController = function MenuController() {

  createOverlay();
  toggleMenu();

  calculateHeight();

  $(window).on("window:resize", function (e) {
    calculateHeight();
  });

  // mobileStickyHeader();
};

var createOverlay = function createOverlay() {
  if ($('.menu-overlay').length === 0) {
    $('body').append('<div class="menu-overlay"></div>');
    if (!$('body').hasClass('show-menu')) {
      $('.menu-overlay').hide();
    }
  }

  $('.menu-overlay').bind('click', function (e) {
    $('body').removeClass('show-menu');

    setTimeout(function () {
      $('.menu-overlay').hide();
      window.allowScroll = true;
    }, 500);
  });
};

var toggleMenu = function toggleMenu() {
  $('.toggle-menu').click(function (e) {

    if ($('body').hasClass('show-menu')) {
      window.allowScroll = true;
      setTimeout(function () {
        $('.menu-overlay').hide();
      }, 500);
    } else {
      window.allowScroll = false;
      $('.menu-overlay').show();
    }

    setTimeout(function () {
      $('body').toggleClass('show-menu');
    }, 10);
  });
};

var calculateHeight = function calculateHeight() {
  var $nav = $('.main-nav');
  var navHeight = $nav.outerHeight();
  var menuHeight = $('.offscreen-menu').height();
  //console.log({'navHeight': menuHeight, 'docHeight': menuHeight});

  if (navHeight > menuHeight) {
    $('.offscreen-menu__main').css({ 'display': 'block' });
  } else {
    $('.offscreen-menu__main').css({ 'display': '' });
  }
};

var mobileStickyHeader = function mobileStickyHeader() {
  enquire.register(__WEBPACK_IMPORTED_MODULE_0__utils_Utils__["b" /* queries */].mobile, {
    match: function match() {

      $(window).on('DOMMouseScroll mousewheel', function (e, delta) {

        var scrollTop = $(window).scrollTop();
        var scrollDir = 'down';
        var headerHeight = $('.header__inner').height();
        // console.log({'delta': delta, 'scrollTop': scrollTop})

        if (delta <= 0) {
          scrollDir = 'up';
        }

        if (scrollDir == 'down' || scrollTop <= $(window).height() / 4 || $('body').hasClass('show-menu')) {
          $('.toggle-menu, .header').css({
            transform: 'translateY(0)'
          });
        } else {
          $('.toggle-menu, .header').css({
            transform: 'translateY(-' + headerHeight + 'px)'
          });

          $('.header').css({
            backgroundColor: 'rgba(0,0,0,0.2)'
          });
        }
      });
    },
    unmatch: function unmatch() {
      $('.toggle-menu, .header').css({
        backgroundColor: '',
        transform: ''
      });

      $(window).off('DOMMouseScroll mousewheel');
    }
  });
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(1)))

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TooltipController; });
var TooltipController = function TooltipController() {

  $('.tooltip-btn').on('click', function (e) {
    e.preventDefault();
    var $parent = $(e.currentTarget).closest('.tooltip');

    $parent.toggleClass('show');
  });
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(enquire, $) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductSliderController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_malihu_custom_scrollbar_plugin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_malihu_custom_scrollbar_plugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_malihu_custom_scrollbar_plugin__);


var ProductSliderController = function ProductSliderController() {

  enquire.register('(max-width:1023px)', {
    match: function match() {
      $('.brands').mCustomScrollbar({
        axis: 'x',
        mouseWheel: true,
        autoDraggerLength: false,
        scrollbarPosition: 'inside',
        documentTouchScroll: true,
        callbacks: {
          onInit: function onInit() {
            // const initBrand = $('.brand:eq(0)').attr('data-brand');
            // $('.brands').find('.mCSB_dragger').append('<span class="scrollerTitle">' + initBrand + '</span>');
          },
          whileScrolling: function whileScrolling() {
            // updateBrand();
          }
        }
      });
    },

    unmatch: function unmatch() {
      $('.brands').mCustomScrollbar('destroy');
    }
  });
};

var updateBrand = function updateBrand() {
  var $items = $('.brand');
  var $dragger = $('.brands').find('.mCSB_dragger');
  var draggerPos = $dragger.offset().left + $dragger.width();

  $items.each(function (i, el) {
    var elX = el.getBoundingClientRect().x;
    var date = $(el).attr('data-brand');

    if (draggerPos > elX) {
      $dragger.find('.scrollerTitle').text(date);
    }
  });
};

var sliderShadow = function sliderShadow() {
  var height = $('.brand__visual__bg').height();

  $('.brands').append('<div class="brands-boxshadow"></div>');
  $('.brands-boxshadow').height(height);

  $(window).on("window:resize", function (e) {
    height = $('.brand__visual__bg').height();
    $('.brands-boxshadow').height(height);
  });
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1), __webpack_require__(0)))

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VideoController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_video_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_CircleButtonAnimation__ = __webpack_require__(29);




var VideoController = function VideoController() {

  $('[data-open="video"]').click(function (e) {

    if (window.circleAnimComplete) {
      var $this = $(e.currentTarget);
      var id = $this.attr('data-id');
      var video = $this.attr('data-video');
      var poster = $this.attr('data-poster');
      var player = '';
      initVideoJs(player, id, poster, video);
    }
  });

  Object(__WEBPACK_IMPORTED_MODULE_1__utils_Utils__["a" /* objectFitter */])('.video-bg-wrapper', 'video');
};

var createMarkup = function createMarkup(poster, file, id) {
  var closeIcon = '<svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><polygon transform="translate(7.144003, 7.144003) rotate(45.000000) translate(-7.144003, -7.144003) " points="-0.759997129 6.07200287 6.08800287 6.07200287 6.08800287 -0.711997129 8.26400287 -0.711997129 8.26400287 6.07200287 15.0480029 6.07200287 15.0480029 8.21600287 8.26400287 8.21600287 8.26400287 15.0000029 6.08800287 15.0000029 6.08800287 8.21600287 -0.759997129 8.21600287"></polygon></svg>';
  closeIcon += '<svg width="54px" height="54px" viewBox="0 0 54 54" class="circle-anim"><circle class="circle" cx="27" cy="27" r="25" stroke-dasharray="160" stroke-dashoffset="160"/></svg>';

  var videoMarkup = '';
  videoMarkup += '<div class="video-wrapper" data-id="' + id + '">';
  videoMarkup += '<div class="video-container" style="opacity: 0;">';
  videoMarkup += '<button class="video-close" data-id="' + id + '" data-close="video"><i class="icn-circle icn-circle--lrg">' + closeIcon + '</i></button>';
  videoMarkup += '<video id="' + id + '" class="video-js" controls muted preload="auto" poster="' + poster + '">';
  videoMarkup += '<source src="' + file + '" type="video/mp4"></source>';
  videoMarkup += '</video>';
  videoMarkup += '</div>';
  videoMarkup += '<div class="video-overlay" data-id="' + id + '" data-close="video" style="opacity: 0;"></div>';
  videoMarkup += '</div>';

  $('body').prepend(videoMarkup);
};

var initVideoJs = function initVideoJs(player, id, poster, video) {
  window.allowScroll = false;

  createMarkup(poster, video, id);

  var options = {
    fluid: true,
    inactivityTimeout: 1000
  };

  player = Object(__WEBPACK_IMPORTED_MODULE_0_video_js__["default"])(id, options);

  player.ready(function () {
    $('.video-overlay').css({ opacity: '1' });
    $('.video-container').css({ opacity: '1' });
    this.play();

    this.on('useractive', function () {
      $('.video-container').removeClass('user-inactive').addClass('user-active');
    });

    this.on('userinactive', function () {
      $('.video-container').removeClass('user-active').addClass('user-inactive');
    });

    this.on('playing', function () {
      $('.video-container').addClass('playing');
    });

    this.on(['waiting', 'pause'], function () {
      $('.video-container').removeClass('playing');
    });
  });

  Object(__WEBPACK_IMPORTED_MODULE_2__utils_CircleButtonAnimation__["a" /* CircleButtonAnimation */])($('.video-close'));

  // $('.video-close').on({
  //   mouseenter: (e) => {
  //     player.options().inactivityTimeout = 0;
  //   },

  //   mouseleave: (e) => {
  //     player.options().inactivityTimeout = 1000;
  //   },
  // })

  $('[data-close="video"]').on('click', function (e) {
    var $this = $(e.currentTarget);
    var id = $this.attr('data-id');

    if (window.circleAnimComplete || $(e.currentTarget).hasClass('video-overlay')) {
      destroyPlayer(player, id);
    }
  });
};

var destroyPlayer = function destroyPlayer(player, id) {
  player.pause();

  $('.video-overlay').css({ opacity: '0' });
  $('.video-container').css({ opacity: '0' });

  setTimeout(function () {
    $('.video-wrapper[data-id="' + id + '"]').remove();
    $('.video-overlay[data-id="' + id + '"]').remove();

    player.dispose();
    window.allowScroll = true;
  }, 500);
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery_validation__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery_validation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery_validation__);


var FormController = function FormController() {
  $('.subscribe-form').each(function (i, el) {
    $(el).validate();
  });
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 94:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuFontController; });
var MenuFontController = function MenuFontController() {

  $('.toggle-menu').on('click', function () {
    if ($(window).width() > 768) {
      var fontSize = $(".offscreen-menu-wrapper").height() * 0.03;
      $('.main-nav__item').css('font-size', fontSize);
    } else {
      var _fontSize = $(".offscreen-menu-wrapper").height() * 0.025;
      $('.main-nav__item').css('font-size', _fontSize);
    }
  });
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MailController; });
var MailController = function MailController() {

  $('.subscribe-submit').on('click', function (e) {
    e.preventDefault();

    if (validateSubscribeForm($(e.currentTarget)) != false) {
      sendForm($(e.currentTarget));
    }
  });
};

var validateSubscribeForm = function validateSubscribeForm(_this) {
  var allow = true;

  _this.parent().removeClass('error');
  _this.parent().nextAll('.a-input__error').hide();

  if (!validateEmail($(_this.parent().find('.text-input')).val())) {
    _this.parent().addClass('error');
    _this.parent().nextAll('.a-input__error').show();
    allow = false;
  }

  return allow;
};

var sendForm = function sendForm(_this) {
  var data = {
    email: _this.parent().find('.text-input').val()
  };

  $.ajax({
    type: 'POST',
    data: data,
    url: 'api/mailchimp/index.php',
    success: function success(result) {
      console.log(result);
      $(_this.parent().find('.text-input')).val("");
      _this.parent().nextAll('.a-input__error').hide();
      _this.parent().nextAll('.a-input__success').show();
    }
  });
};

var validateEmail = function validateEmail(dataEmail) {
  var val = dataEmail;
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(val);
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AgecheckController; });
var AgecheckController = function AgecheckController() {

  // if(window.location.href.indexOf("sezoens") > -1 || window.location.href.indexOf("martens.staging.radikal.io") > -1) {
  //   // Set Sezoens cookie
  //   isSetCookie('sezoens_agecheck');
  // } else if (window.location.href.indexOf("kristoffel") > -1) {
  //   // Set Kristoffel cookie
  //   isSetCookie('kristoffel_agecheck');
  // }

  if ($('.agecheck').length > 0) {
    window.allowScroll = false;

    $('.js-agree').on('click', function (e) {
      var cookieName = $(e.currentTarget).attr('data-cookie-name');
      setCookie(cookieName, true, 30);
      $('.agecheck').addClass('hide');
      $('body').removeClass('show-agecheck');
      window.allowScroll = true;
    });
  }
};

var setCookie = function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

// let isSetCookie = (name) => {
//   if(!getCookie(name)) {
//     $('.agecheck').removeClass('hide');
//     window.allowScroll = false;

//     $('.js-agree').on('click', (e) => {
//       setCookie(name, true, 30);
//       $('.agecheck').addClass('hide');
//       window.allowScroll = true;
//     })
//   }
// }


// let getCookie = (name) => {
//   var nameEQ = name + "=";
//   var ca = document.cookie.split(';');
//   for(var i=0;i < ca.length;i++) {
//       var c = ca[i];
//       while (c.charAt(0)==' ') c = c.substring(1,c.length);
//       if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
//   }
//   return null;
// }
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 97:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CircleButtonController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_CircleButtonAnimation__ = __webpack_require__(29);


var CircleButtonController = function CircleButtonController() {
  var $icons = $('.icn-circle');
  var circlSVG = '<svg width="54px" height="54px" viewBox="0 0 54 54" class="circle-anim"><circle class="circle" cx="27" cy="27" r="25" stroke-dasharray="160" stroke-dashoffset="160"/></svg>';

  $icons.each(function (i, el) {

    var $this = $(el);
    var $button = $this.parent();

    $this.append(circlSVG);

    Object(__WEBPACK_IMPORTED_MODULE_0__utils_CircleButtonAnimation__["a" /* CircleButtonAnimation */])($button);
  });
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ })

},[34]);


// WEBPACK FOOTER //
// shared/js/shared.bundle.js